import React from 'react';
import './Card.css';

interface CardProps {
  children: React.ReactNode;
  elevation?: 'sm' | 'md' | 'lg';
  padding?: string;
  className?: string;
}

const Card: React.FC<CardProps> = ({ 
  children, 
  elevation = 'md', 
  padding = '24px',
  className = ''
}) => {
  return (
    <div 
      className={`card card-elevation-${elevation} ${className}`}
      style={{ padding }}
    >
      {children}
    </div>
  );
};

export default Card;